import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b3bb63b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"5px","padding-inline":"4px"} }

import { ref, onMounted, watch, computed, withDefaults } from 'vue';
import { setLocale, getLocale } from "@/utils/locale";
import { IOptionsSelectFlag } from '@/types';

interface IProps {
  modelValue?: any;
  options?: IOptionsSelectFlag[];
  placeholder?: string;
  label?: string;
  width?: string;
  multiple?: boolean;
  disabled?: boolean;
  isCalendar?: boolean;
  required?: boolean;
  hasError?: boolean;
  msgError?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSelectFlag',
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: 'Selecione' },
    label: {},
    width: { default: 'auto' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isCalendar: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    msgError: {}
  },
  emits: ['onChangeDropDownList', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const selectedItem = ref<string>('');

// Observa mudanças na seleção e salva no localStorage
watch(selectedItem, (newValue) => {
  if (newValue) {
    setLocale(newValue);
    emit('onChangeDropDownList', newValue);
  }
});

// Carrega o valor salvo ao iniciar o componente
onMounted(() => {
  const savedLocale = getLocale();
  if (savedLocale) {
    selectedItem.value = savedLocale;
  } else {
    selectedItem.value = props.options?.find((x) => x.selected)?.value || '';
    emit('onChangeDropDownList', selectedItem.value);
    setLocale(selectedItem.value);
  }
});

// Atualiza o valor selecionado quando as opções mudam
watch(() => props.options, () => {
  if (!selectedItem.value) {
    selectedItem.value = props.options?.find((x) => x.selected)?.value || '';
    emit('onChangeDropDownList', selectedItem.value);
    setLocale(selectedItem.value);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: props.width })
  }, [
    _createVNode(_component_v_select, {
      modelValue: selectedItem.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
      placeholder: props.placeholder,
      items: props.options,
      "item-value": "value",
      density: "compact",
      variant: "outlined",
      "item-title": "selected",
      required: false,
      disabled: false,
      "hide-details": true,
      class: "pa-0"
    }, {
      item: _withCtx(({ props, item }) => [
        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_country_flag, {
                      country: item.raw.value,
                      rounded: "true",
                      size: "medium"
                    }, null, 8, ["country"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "10",
                  class: "pl-5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.raw.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040)
      ]),
      selection: _withCtx(({ }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_country_flag, {
            country: selectedItem.value,
            rounded: "true",
            size: "medium"
          }, null, 8, ["country"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "items"])
  ], 4))
}
}

})